<template>
<div>


<h2 class="goth">Perfekt av starka verb</h2>

<div class="grammatikparagrafbredd leftorient">
<h4>Perfektparticip av starka verb</h4>
<br>
<div class="p-stil quasi-p">Perfektparticipformen av <u>starka verb</u> bildas genom <div class="understryk-gul"><nobr><b>ge</b> + [perfekt-stam] + <b>en</b></nobr></div>. (Jämför med de svaga verben som alltid
slutar på <b>-t</b> i perfektparticip.)</div>

<p>Hur perfektstammen ser ut i förhållande till infinitivformen (grundformen) är hos de starka verben olika från verb till verb och måste
    läras in specifikt för varje starkt verb. Oftast ändras vokalen.</p>

<p>Några exempel på vanliga starka verb</p>


</div>



<div class="grammatikparagrafbredd leftorient">


<table class="">

    <tr class="leftorient">
        <th class="ljusgra">
        <th class="ljusgra">infinitiv</th>
        <th class="ljusgra">perfekt</th>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">få</td>
        <td class="ljusgra"><i>bekomm</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div> bekomm<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">äta</td>
        <td class="ljusgra"><i>ess</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div><b> geg</b>ess<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">finna</td>
        <td class="ljusgra"><i>find</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>fund<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">läsa</td>
        <td class="ljusgra"><i>lesen</i>|<i>en</i></td>
        <td class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>les<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">ta</td>
        <td  class="ljusgra"><i>nehm</i>|<i>en</i></td>
        <td  class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>nomm<b>en</b></i></td>
    </tr>


    <tr class="leftorient">
        <td  class="ljusgra">prata</td>
        <td  class="ljusgra"><i>sprechen</i>|<i>en</i></td>
        <td  class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>sproch<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td  class="ljusgra">sova</td>
        <td  class="ljusgra"><i>schlafen</i>|<i>en</i></td>
        <td  class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>schlaf<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td  class="ljusgra">skriva</td>
        <td  class="ljusgra"><i>schreib</i>|<i>en</i></td>
        <td  class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>schrieb<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td  class="ljusgra">se</td>
        <td  class="ljusgra"><i>sehen</i>|<i>en</i></td>
        <td  class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>seh<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td  class="ljusgra">bära</td>
        <td  class="ljusgra"><i>tragen</i>|<i>en</i></td>
        <td  class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>trag<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td  class="ljusgra">träffa</td>
        <td  class="ljusgra"><i>treff</i>|<i>en</i></td>
        <td  class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>troff<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td  class="ljusgra">dricka</td>
        <td  class="ljusgra"><i>trink</i>|<i>en</i></td>
        <td  class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>trunk<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td  class="ljusgra">glömma</td>
        <td  class="ljusgra"><i>vergess</i>|<i>en</i></td>
        <td  class="ljusgra"><i><div class="minitext">er hat </div> vergess<b>en</b></i></td>
    </tr>

    <tr class="leftorient">
        <td  class="ljusgra">tvätta</td>
        <td  class="ljusgra"><i>wasch</i>|<i>en</i></td>
        <td  class="ljusgra"><i><div class="minitext">er hat </div><b> ge</b>wasch<b>en</b></i></td>
    </tr>


</table>

<p class="minitext">I tabellen ovan har ett lodrätt streck | använts för att skilja verbstammen från infinitivändelsen.</p>
</div>
</div>

</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "perfekt starka verb"
            }
        ]
    }
},


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
